import { HttpResponse } from "./createEnquiry";

export async function addQuoteToBasket(
  basketApiBaseUrl: string,
  tradeInQuoteId: string,
): Promise<HttpResponse> {
  const { url, options } = await requestBuilder(
    basketApiBaseUrl,
    tradeInQuoteId,
  );

  return await fetch(url, options)
    .then(async function (response: Response) {
      const { status } = response;
      if (response.ok && status >= 200 && response.status <= 299) {
        return { status: status, body: response.json() };
      }
      return { status: status, error: "Add quote failed" };
    })
    .catch(() => {
      return { status: 400, error: "Add quote failed" };
    });
}

async function requestBuilder(
  basketApiBaseUrl: string,
  tradeInQuoteId: string,
) {
  const auth0 = () => window.__auth0__ || window.auth0;
  const token = await auth0()?.getTokenIfAuthenticated();
  const clientId = "web_pdp_scaffold_ui";
  const url = `${basketApiBaseUrl}/trade-in-quote/${tradeInQuoteId}`;

  const reqHeaders = new Headers();
  reqHeaders.append("Content-Type", "application/json");
  reqHeaders.append("x-api-client-id", `${clientId}`);
  if (token) {
    reqHeaders.append("Authorization", `Bearer ${token}`);
  }

  const options: RequestInit = {
    method: "POST",
    credentials: "include",
    body: null,
    headers: reqHeaders,
  };

  return { url, options };
}
